import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Select } from "@/components/ui/select";

/** Discount / tax / note — shared by Advanced disclosure and Floor sheet. */
export function PosTicketOptionsFields(props: {
  drawerOpen: boolean;
  discountSoftCapPct: number;
  orgTaxPriceMode: string;
  orgTaxRatePct: number;
  discountPct: string;
  taxPriceMode: "" | "inclusive" | "exclusive";
  taxRatePct: string;
  ticketNote: string;
  onDiscountPct: (v: string) => void;
  onTaxPriceMode: (v: "" | "inclusive" | "exclusive") => void;
  onTaxRatePct: (v: string) => void;
  onTicketNote: (v: string) => void;
  onDiscountEdited?: () => void;
}) {
  return (
    <div className="space-y-4">
      <label className="block text-xs text-[var(--color-muted)]">
        Discount % (cap {props.discountSoftCapPct}%)
        <Input
          className="mt-1 min-h-11 font-mono"
          inputMode="decimal"
          placeholder="0"
          value={props.discountPct}
          onChange={(e) => {
            props.onDiscountPct(e.target.value);
            props.onDiscountEdited?.();
          }}
          disabled={!props.drawerOpen}
        />
      </label>
      {props.drawerOpen && (
        <div className="space-y-3">
          <p className="m-0 text-xs text-[var(--color-muted)]">
            Org tax: {String(Number(props.orgTaxRatePct))}%{" "}
            {props.orgTaxPriceMode}. Leave blank to keep it.
          </p>
          <div className="grid gap-3">
            <div>
              <Label htmlFor="pos-tax-mode">Tax price mode</Label>
              <Select
                id="pos-tax-mode"
                className="mt-1 min-h-11"
                value={props.taxPriceMode}
                onChange={(e) =>
                  props.onTaxPriceMode(
                    e.target.value as "" | "inclusive" | "exclusive",
                  )
                }
              >
                <option value="">
                  Org default ({props.orgTaxPriceMode})
                </option>
                <option value="inclusive">Inclusive</option>
                <option value="exclusive">Exclusive</option>
              </Select>
            </div>
            <div>
              <Label htmlFor="pos-tax-rate">Tax rate %</Label>
              <Input
                id="pos-tax-rate"
                className="mt-1 min-h-11 font-mono"
                inputMode="decimal"
                value={props.taxRatePct}
                onChange={(e) => props.onTaxRatePct(e.target.value)}
                placeholder={String(Number(props.orgTaxRatePct))}
              />
            </div>
          </div>
        </div>
      )}
      <label className="block text-xs text-[var(--color-muted)]">
        Note (optional)
        <Input
          className="mt-1 min-h-11"
          maxLength={500}
          placeholder="Customer name, table…"
          value={props.ticketNote}
          onChange={(e) => props.onTicketNote(e.target.value)}
          disabled={!props.drawerOpen}
        />
      </label>
    </div>
  );
}
